import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfig, ENV_CONFIG } from 'src/environments/environment.model';

@Injectable({
  providedIn: 'root'
})
export class UploadsService {

  constructor(
    @Inject(ENV_CONFIG) private config: EnvironmentConfig,
    private http: HttpClient
  ) { }

  uploadFile(obj: { file: any, metadata: { partNumber: string, container: string } }): Observable<any> {
    const endpoint = this.config.endpoints.baseApi;
    const payload = new FormData();
    payload.append('partNumber', obj.metadata?.partNumber);
    payload.append('azureContainer', obj.metadata?.container);
    payload.append('File', obj.file.file);

    return this.http.post<any>(
      `${endpoint.url}api/${endpoint.version}/uploads`, payload, { headers: { 'Content-Disposition': 'multipart/form-data' }, reportProgress: true, observe: 'events' }
    );
  }
}
